import { defineRouting } from 'next-intl/routing';

// Locales actuellement servies par l'application.
// Ajouter une locale = ajouter ici + créer `messages/<locale>.json`.
export const locales = ['fr', 'en'] as const;
export const defaultLocale = 'fr' as const;

// Fuseau horaire global par défaut (next-intl v4 l'exige : sans lui, tout
// `format.dateTime`/`relativeTime` lève `ENVIRONMENT_FALLBACK` et crashe le
// sous-arbre. Marché FR → Europe/Paris). Partagé serveur (request.ts) + client
// (IntlProvider) pour garantir l'absence de mismatch d'hydratation.
export const defaultTimeZone = 'Europe/Paris' as const;

export type Locale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale,
  // URLs identiques pour toutes les locales : la langue est résolue côté serveur
  // via le cookie `NEXT_LOCALE` puis l'en-tête `Accept-Language`.
  localePrefix: 'never',
  // next-intl écrit `NEXT_LOCALE` automatiquement quand l'utilisateur change de langue.
  localeCookie: {
    name: 'NEXT_LOCALE',
    sameSite: 'lax',
  },
  localeDetection: true,
});
